<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'

import WelcomeCard from './shared/welcome-card'
import LatestOrdersCard from './shared/latest-orders-card'
import OrdersSummaryCard from './shared/orders-summary-card'
import CartInfo from './shared/cart-info'
import RejectedOrders from './shared/rejected-orders'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    AppLayout,
    PageHeader,
    WelcomeCard
  },
  data () {
    return {
      title: 'Dashboard',
      items: [
        {
          text: 'Dashboards',
          href: '/'
        },
        {
          text: 'Admin',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="title" :items="items" />

    <welcome-card />
  </AppLayout>
</template>
